// This file is generated at build time with environment variables
export const RUNTIME_CONFIG = {
	CDN_BASE_PATH: import.meta.env.VITE_CDN_BASE_PATH || '',
	IS_DEV: import.meta.env.DEV || false,
	IS_LEGACY_LOCAL_ENV: import.meta.env.VITE_IS_LEGACY_LOCAL_ENV || false,
	MODE: import.meta.env.MODE || 'production',
};
